import ABCyaLib from "@abcya/abcya_lib";

export default function setupGameConfig(variantId, locale) {
  const config = {
    // add your game config options here, these can be the default values
    hasLocalePatches: false,
    menuButtonTextYPosition: 45
  };
  switch (locale) {
    // switch on your variant IDs here and set the needed config values
    case ABCyaLib.Environment.LOCALES.esUS:
      config.hasLocalePatches = true;
      config.menuButtonTextYPosition = 46;
      break;
  }
  return config;
}